export const childAbuseHTML = (logo) => {
  return (`
  <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Votiamo App - Privacy Policy</title>
  <style>
      body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          margin: 0;
          padding: 0;
          background-color: #f9f9f9;
          color: #333;
      }
      header {
          text-align: center;
          padding: 20px 0;
          background-color: #fff;
      }
      header img {
          width: 150px;
          height: auto;
      }
      header h1 {
          margin: 10px 0 0;
          font-size: 24px;
          color: #0073a6;
      }
      main {
          padding: 20px;
          max-width: 90%;
          margin: 20px auto;
      }
      h2 {
          color: #005580;
          margin-top: 20px;
      }
      h3 {
          color: #333;
          margin-top: 15px;
      }
      p {
          margin: 10px 0;
      }
      ul {
          margin: 10px 0 20px;
          padding-left: 20px;
      }
      footer {
          text-align: center;
          padding: 10px 0;
          font-size: 12px;
          color: #777;
      }
      .highlight {
          font-weight: bold;
          color: #0073a6;
      }
  </style>
</head>
<body>
  <header>
      <img src="${logo}" alt="Votiamo App Logo">
      <h1>Votiamo App - Privacy Policy</h1>
  </header>
  <main>
      <section>
    <h2>Child Sexual Abuse and Exploitation (CSAE) Standards</h2>
    <p>At Votiamo, we are committed to providing a safe and respectful environment for all users, especially children. We take a zero-tolerance approach to child sexual abuse and exploitation (CSAE) and have implemented strong internal policies to prevent and respond to such incidents.</p>
    
    <p>Our CSAE protection efforts include the following:</p>

    <ul>
        <li><strong>Monitoring Content:</strong> We monitor user-generated content (if applicable) to identify and block any material that may relate to CSAE or other harmful behaviors.</li>
        <li><strong>Reporting Tools:</strong> We provide clear and easy ways for users to report inappropriate content or behavior directly within the app.</li>
        <li><strong>Law Enforcement Cooperation:</strong> We cooperate fully with law enforcement and appropriate authorities in the event of any reported or suspected CSAE activity.</li>
        <li><strong>Educational Awareness:</strong> We aim to educate our users, especially parents and guardians, about online safety and how to recognize potential CSAE-related risks.</li>
        <li><strong>Regular Internal Reviews:</strong> We perform internal safety reviews to ensure that our protective measures remain effective and up to date.</li>
    </ul>

    <p>While we have not yet published formal CSAE standards externally, we are actively working toward making our internal policies and procedures public for full transparency.</p>

    <p>If you believe you have encountered any inappropriate content or behavior related to CSAE, please contact us immediately at <a href="mailto:support@votiamo.com">support@votiamo.com</a>.</p>
</section>
  </main>

 
  <footer>
      <p>&copy; 2025 Il Cavedio Società Cooperativa. All rights reserved.</p>
  </footer>
</body>
</html>
  `)
};